<template>
  <div class="triplea-login-wrapper">
    <div class="triplea-login-form-wrapper">
      <div>
        <!-- First Name -->
        <vs-input
          name="firstName"
          icon="icon icon-user"
          icon-pack="feather"
          label-placeholder="First Name"
          v-model="firstName"
          class="w-full no-icon-border mb-2"
        />
        <!-- Last Name -->
        <vs-input
          name="lastName"
          icon="icon icon-user"
          icon-pack="feather"
          label-placeholder="Last Name"
          v-model="lastName"
          class="w-full no-icon-border mb-2"
        />
        <!-- Email -->
        <vs-input
          name="email"
          type="email"
          icon="icon icon-lock"
          icon-pack="feather"
          label-placeholder="Email"
          v-model="email"
          danger-text="Email format is not valid"
          class="w-full no-icon-border mb-2"
        />

        <!-- Mobile Phone -->
        <vs-input
          name="phone"
          type="text"
          icon="icon icon-lock"
          icon-pack="feather"
          label-placeholder="Mobile Phone"
          v-model="phoneNum"
          class="w-full no-icon-border mb-2"
        />

        <br />
        <vs-button
          class="w-full mb-2"
          @click="register()"
          id="registerBtn"
          ref="registerBtn"
          >Register</vs-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // noRedirect: false,
    // displayTransition: false
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      phoneNum: '',
    };
  },
  computed: {},
  mounted() {},
  methods: {
    backToLogin() {
      this.$store.commit('GO_TO_SIGN_UP', false);
    },

    register() {
      this.apiSignUpNewUser(
        this.firstName,
        this.lastName,
        this.email.trim(),
        this.phoneNum
      )
        .then((result) => {
          console.log('result in SIgn Up component', result);
        })
        .catch((error) => {
          console.log('Error in Signup component', error);
        });
    },
  },
};
</script>

<style>
.triplea-login-wrapper {
  /*max-width: 300px;*/
}
</style>
